import styled from 'styled-components';

import { Separator } from '@thinknet-gmbh/platform-common-ui';

export const MainContainer = styled.div`
  & > div:first-child {
    margin-bottom: 16px;
  }
  form {
    .ant-form-item {
      width: 288px;
    }
  }
`;

export const FormListContent = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const FormListElementWrapper = styled.div`
  margin-right: 48px;
  margin-bottom: 16px;
`;

export const FormListPermission = styled.div`
  display: flex;
  & > div:last-child {
    margin-left: 18px;
    align-self: flex-start;
    margin-top: 34px;
    cursor: pointer;
  }
`;

export const FormListRule = styled.div`
  display: flex;
  flex-direction: column;
  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const ButtonContainer = styled.div`
  align-self: flex-end;
  margin-right: 40px;
  .ant-btn {
    padding: 0;
    :hover {
      background: transparent;
    }
  }
`;

export const ContentSeparator = styled(Separator)`
  margin: 6 px 0;
`;
